<template>
  <v-container>
    <v-data-table :headers="headers" :items="items" class="elevation-0" disable-pagination hide-default-footer>
      <template slot="item" slot-scope="props">
        <tr>
          <!-- <td style="text-align: left">{{ props.item.cable }}</td> -->
          <td style="text-align: left">{{ props.item.description }}</td>
          <td v-if="props.item.totalForced" style="text-align: left">{{ props.item.totalForced }}</td>
          <td v-else style="text-align: left">{{ props.item.total }}</td>
          <td style="text-align: center">
            <span v-if="!props.item.exceeded">
              <v-icon color="green">check_circle_outline</v-icon>
            </span>
            <span v-if="props.item.exceeded">
              <v-icon color="red">error_outline</v-icon>
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-divider class="mb-3"></v-divider>
  </v-container>
</template>

<script>
  import { mapMutations, mapGetters, mapActions } from "vuex";

  export default {
    name: "macro-activities",
    data() {
      return {
        headers: [
          //{ text: this.$t('vessel.cable'), align: 'start', value: 'description' },
          { text: this.$t('vessel.mAct'), align: 'start', value: 'description' },
          { text: this.$t("vessel.hours"), value: "total", width: "150px" },
          { text: this.$t("vessel.check"), value: "exceeded", width: "100px", align: "center", sortable: false, },
        ],
        currentMainDprId: null,
        currentPVId: null,
      };
    },
    computed: {
      ...mapGetters([
        "mv_vesselMacroActivity/getMacroActivities",
        "mv_dprData/getDprPVId",
        "mv_dprData/getCurrentDprMainId",
      ]),
      items() {
        return this["mv_vesselMacroActivity/getMacroActivities"];
      },
    },
    created() {
      this.currentMainDprId = this.$route.params.dprMainId;
      this.currentPVId = this.$route.params.pvId;
      this["mv_vesselMacroActivity/fetchMacroActivitiesByDprId"](
        this.currentMainDprId
      );
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.mHideLongLoader();
      });
    },
    methods: {
      ...mapMutations(["mHideLongLoader"]),
      ...mapActions(["mv_vesselMacroActivity/fetchMacroActivitiesByDprId"]),
    },
  };
</script>
<style scoped>
  .container {
    max-width: 95%;
  }
</style>
